(function(){
    'use strict'

    angular
    .module('app.usuarios-organizador')
    .controller('EditarUsuarioOrganizador', EditarUsuarioOrganizador);

    EditarUsuarioOrganizador.$inject = ['$q', '$scope', '$animationsSrv', '$routeParams', 'UsuariosOrganizadorService', 'GruposService', 'logger', '$location', 'UserInfoService', 'ApiBaseService'];

    function EditarUsuarioOrganizador($q, $scope, $animationsSrv, $routeParams, UsuariosOrganizadorService, GruposService, logger, $location, UserInfoService, ApiBaseService) {
    
        $animationsSrv.scrollToTop();
        
        var vm = this;

        vm.usuarioId = $routeParams.id ? $routeParams.id : 0;
        
        vm.grupos = [];
        vm.eventos = [];
        vm.eventosUsuario = [];

        vm.usuario = {
            grupoId: -1,
            verTodosLosEventos: true
        };

        vm.evento = {
            id: 0,
        };

        vm.permisoEvento = {
            id: 0,
            usuarioId: 0,
            eventoId: 0
        };

        vm.uiData = {
        };

        var promiseGrupo = getGrupos();

        if(vm.usuarioId){
            getById();
        }

        getComboData(vm.eventos, 'api/Eventos/All', null, 'Error al cargar los eventos');

        function getGrupos(){
            var promise = GruposService.getAll()
            .then(function(grupos){
                vm.grupos = grupos;
            })
            .catch(function(error){
                $logger.error('Error al obtener los grupos')
            }); 
            
            return promise;
        };

        function getComboData(array, apiUrl, params, errorMessage){
            ApiBaseService.remoteController = apiUrl;
            var promise = ApiBaseService.getAll(params)
            .then(function(data){
                array.splice(0);
                array.push(...data);
            })
            .catch(function(error){
                $logger.error(errorMessage);
            }); 
            
            return promise;
        };

        function getById(){

            $q.all([promiseGrupo])
            .then(function(){
                UsuariosOrganizadorService.getById(vm.usuarioId)
                .then(function(usuario){
                    vm.usuario = usuario;
                    getComboData(vm.eventosUsuario, 'api/permisos-eventos', [vm.usuario.id], 'Error al cargar los eventos del usuario');
                })
                .catch(function(error){
                    $logger.error('Error al obtener los datos del usuario')
                }); 
            });
        }

        function doFormValidations()
        {
            validateSelectProperty($scope.usuarioForm, vm.usuario, 'usergrupo' );
        };

        vm.openModal = function(modalName){
            $(modalName).modal('toggle');    
        };

        vm.save = function(){

            $scope.submitted = true;

            if(vm.usuario.grupoId == -1){
                $scope.usuarioForm.usergrupo.$setValidity("different", false);
            }

            doFormValidations();

            if($scope.usuarioForm.$valid){
                if(!vm.usuario.id){
                    vm.usuario.id = 0;
                    saveUser();
                }
                else{
                    if($scope.usuarioForm.$dirty){
                        updateUser();
                    }
                    else{
                        logger.info('No has modificado ningún dato');
                    }
                }
                
            }
            else{
                logger.error('Por favor corrija los datos');
            }
        
        };

        function saveUser() {
            var promise = UsuariosOrganizadorService.save(vm.usuario);
                
            promise
            .then(function(response){
                vm.usuario.id = response.data.id;
                vm.usuario.organizadorId = response.data.organizadorId;
                logger.success('Usuario creado con éxito.');
            })
            .catch(function(error){
                switch (error.status) {
                    case 500:
                    logger.error(`Hubo un erro al crea el usuario: ${error.data.Message}`);
                        break;
                
                    default:
                        logger.error('Hubo un erro al crea el usuario');
                        break;
                }
            }); 
        }

        function updateUser() {
            var promise = UsuariosOrganizadorService.update(vm.usuario);
                
            promise
            .then(function(response){
                getComboData(vm.eventosUsuario, 'api/permisos-eventos', [vm.usuario.id], 'Error al cargar los eventos del usuario');
                logger.success('Usuario modificado con éxito.');
            })
            .catch(function(error){
                logger.error('Hubo un erro al modificar el usuario');
            }); 
        }

        vm.clearUserData = function(){
            $scope.submitted = false;

            vm.usuarioId = 0;
            // Reset the form model.
            vm.usuario = {
                grupoId: -1,
                verTodosLosEventos: true
            };

            vm.permisoEvento = {
                id: 0,
                usuarioId: 0,
                eventoId: 0
            };

            vm.evento.id = 0;
            vm.eventosUsuario = [];

            // Set back to pristine.
            $scope.usuarioForm.$setPristine();
            // Since Angular 1.3, set back to untouched state.
            $scope.usuarioForm.$setUntouched();
        }

        function validateSelectProperty(form, object, property){
            if(object[property] == 0){
                form[property].$setValidity("different", false);
                return false;
            }
            else{
                form[property].$setValidity("different", true);
                return true;
            }
        };

        vm.onSelectChanged = function(property){

            switch (property) {
                case "usergrupo":
                    onUsergrupoChanged(property);
                    break;
                default:
                    break;
            }
        };

        function onUsergrupoChanged(property)
        {
            validateSelectProperty($scope.usuarioForm, vm.usuario, property );
        };

        vm.saveEvento = function(){

            if(vm.evento.id == 0){
                logger.error('No se ha seleccionado el evento');
                return;
            }

            if(vm.usuario.id == 0){
                logger.error('No se ha seleccionado el usuario');
                return;
            }

            var existeEvento = vm.eventosUsuario.find((e) => e.eventoId == vm.evento.id);

            if(existeEvento){
                logger.error('El evento ya fue agregado');
                return;
            }

            vm.permisoEvento.usuarioId = vm.usuario.id;
            vm.permisoEvento.eventoId = vm.evento.id;

            var promise = UsuariosOrganizadorService.saveEvento(vm.permisoEvento);
                
            promise
            .then(function(response){
                logger.success('Evento agregado con éxito.');
                getComboData(vm.eventosUsuario, 'api/permisos-eventos', [vm.usuario.id], 'Error al cargar los eventos del usuario');
            })
            .catch(function(error){
                switch (error.status) {
                    case 500:
                    logger.error(`Hubo un erro al agregar el evento: ${error.data.Message}`);
                        break;
                
                    default:
                        logger.error('Hubo un error al agregar el evento');
                        break;
                }
            }); 
        
        };

        vm.delete = function(evento){
            var promise = UsuariosOrganizadorService.removeEvento(evento);
            
            promise
            .then(function(response){
                vm.eventosUsuario = vm.eventosUsuario.filter(function(u) {
                    return u.id !== evento.id;
                });
                logger.success('Evento removido con éxito.');
            })
            .catch(function(error){
                switch (error.status) {
                    case 500:
                        logger.error(error.data.Message);
                        break;
                    case 401:
                        logger.error('La sessión ha terminado.');
                        break;
                    default:
                        logger.error('Hubo un erro al remover el evento');
                        break;
                }
                
            });   
        };
    }
})();